import React from 'react';
import { FormSelectProps } from './types';
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import './FormSelect.scss';

export const FormSelect = <T extends { name: string }>({
  selectedItem,
  items,
  className = '',
  disabled,
  placeholder = '',
  uniqueId = 'name',
  onSelect,
}: FormSelectProps<T>) => {
  const getItemSelectHandler = (item: T) => () => onSelect(item);
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <FormControl size="small" fullWidth disabled={disabled}>
        <InputLabel color="primary" size="small" id="status-select-label">
          {placeholder}
        </InputLabel>
        <Select
          color="primary"
          size="small"
          labelId="form-select-label"
          id="status-select"
          className="form-select-input"
          disabled={disabled}
          value={
            uniqueId
              ? selectedItem?.[uniqueId] ?? selectedItem?.name ?? ''
              : selectedItem?.name ?? ''
          }
          label={placeholder}
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 200 },
            },
          }}
        >
          {items.map((item, i) => (
            <MenuItem
              key={i}
              value={uniqueId ? (item[uniqueId] as any) : item.name}
              color="primary"
              onClick={getItemSelectHandler(item)}
            >
              <ListItemText color="primary">{item.name}</ListItemText>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
